import { useContext } from 'react';
import { LanguageContext } from '../context/LanguageContext';

/**
 * Custom Hook for accessing Language Context
 * Returns: { language, setLanguage, toggleLanguage, getText }
 *
 * Usage:
 * const { language, setLanguage, getText } = useLanguage();
 */
const useLanguage = () => {
  const context = useContext(LanguageContext);

  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }

  return context;
};

export default useLanguage;
